module.exports = __webpack_public_path__ + "static/media/deer-stone_preview.60f84fda.png";